import type { StaticLayerPayload } from "@config";
import { TableLibrary } from "@library-elements/table";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: TableLibrary,
};

export const Table = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
